export default __webpack_public_path__ + "static/media/charcs-chimestry.33bab07e.jpg";